import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IClearanceApproval } from "@/models//clearance-approval.entity";
import clearanceApprovalService from "@/services/mrfiktiv/services/clearance-approval.service";
import { MrfiktivClearanceApprovalControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const ClearanceApprovalPageDataProvider = new (class extends AbstractPageDataProvider<
  IClearanceApproval,
  MrfiktivClearanceApprovalControllerGetParamsGen
> {
  async getPage(query: MrfiktivClearanceApprovalControllerGetParamsGen): Promise<IPageViewModel<IClearanceApproval>> {
    const res = await clearanceApprovalService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IClearanceApproval[];

    return { meta, data };
  }
})();
